<template>
	<div v-show="domaines.length" class="encart-votre-formation">
		<span class="title">
			<span class="first-line">Trouvez votre formation</span>
			<span class="second-line">dans le secteur qui vous plaît</span>
		</span>
		<div class="domaine-liste">
			<a
				v-for="domaine in domaines"
				:key="domaine.libelle"
				:href="domaine['link-web'] ? domaine['link-web'] : '#'"
				@mouseover="onItemDomaineHover"
				@mouseleave="onItemDomaineHover(false)"
				class="domaine-item"
				:data-color="domaine.couleur"
			>{{domaine.libelle}}</a>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
/**
 * Composant permettant d'afficher l'encart "Trouver votre formation" de la sidebar
 *
 * @version 1.0.0
 */
export default {
	name: 'EncartVotreFormation',
	props: {},
	data() {
		return {
			domaines: [],
		};
	},
	mounted() {
		axios
			.get('https://blog.greta-cfa-paysdelaloire.fr/webgreta/json-liste-secteurs.php')
			.then((res) => {
				this.domaines = res.data;
			})
			.catch((err) => {
				console.log(err);
			});
	},
	methods: {
		onItemDomaineHover(hovered = true) {
			event.currentTarget.style.color = hovered ? event.currentTarget.dataset.color : '';
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

.encart-votre-formation {
	display: flex;
	flex-direction: column;
	color: $mainColor;
	background-color: white;
	border-radius: 15px;
	padding: 30px 0;
	text-align: center;

	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 0 30px;

		.first-line {
			font-size: 20px;
			line-height: 20px;
			color: $secondaryColor;
		}

		.second-line {
			font-size: 30px;
			line-height: 25px;
			font-weight: bold;
			font-style: italic;
		}
	}

	.domaine-liste {
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		padding: 0;
		margin-top: 25px;
		padding-left: 25px;
		text-align: left;
	}

	.domaine-item {
		position: relative;
		font-size: 15px;
		text-decoration: none;
		color: #163658;
		font-weight: bold;
		z-index: 1;

		&::before {
			content: '';
			position: absolute;
			top: 10px;
			left: 0;
			width: 100%;
			height: 17px;
			z-index: -1;
			background-color: #ececec;
			opacity: 0;
			transition: all 0.3s ease-in-out;
		}

		+ .domaine-item {
			margin-top: 20px;
		}

		&:hover {
			&::before {
				opacity: 1;
				left: 15px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/EncartVotreFormation.vue